// src/currencyApi.js
import axios from 'axios';
import config from './config';

// Fetch all supported currencies
export const getSupportedCurrencies = async () => {
  const response = await axios.get(`${config.API_BASE_URL}/Product/currencies`);
  return response.data;
};

// Update user's preferred currency in database
export const updateUserCurrency = async (userId, currencyCode) => {
  const response = await axios.put(`${config.API_BASE_URL}/UsersApi/${userId}/currency`, {
    PreferredCurrency: currencyCode
  });
  return response.data;
};

// Fetch user's preferred currency
export const getUserCurrency = async (userId) => {
  const response = await axios.get(`${config.API_BASE_URL}/UsersApi/${userId}`);
  return response.data.PreferredCurrency || response.data.preferredCurrency || 'YER';
};
